import React from "react";
import { Input } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import icons from "../../constants/icons";
import { saveProfileUnits } from "../../actions/ProfileUnits";
import api from "../../utils/api";

class BusinessAddress extends React.Component {
  state = {
    error: {},
    location: "",
    city: "",
    town: "",
    postalAddress: "",
  };

  componentDidMount() {
    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  }

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });
  }

  validateForm() {
    let { error, location, city, town, postalAddress } = this.state;

    if (location === "") {
      error.location = language[this.props.defaultLanguage].location_required;
    }

    if (city === "") {
      error.city = language[this.props.defaultLanguage].city_required;
    }

    if (town === "") {
      error.town = language[this.props.defaultLanguage].town_required;
    }

    if (postalAddress === "") {
      error.postalAddress =
        language[this.props.defaultLanguage].postal_address_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, location, city, town, postalAddress, id } = this.state;
    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("profile")}/address`,
        data: {
          location,
          city,
          town,
          postalAddress,
          addressId: id || "",
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "address_update_success"
                : "address_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
          this.handleUpdateProfileUnitsStorage("ADDRESS");
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== "" ? "address_update_error" : "address_added_error"
            ]
          );
        });
    }
  };

  handleUpdateProfileUnitsStorage = async (unit) => {
    const { profileUnits } = this.props;

    const modifiedUnits = profileUnits?.map((el) => {
      if (el.unit === unit && !el.provided) {
        el.provided = true;
      }

      return el;
    });

    await this.props.dispatch(saveProfileUnits(modifiedUnits));
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Input
            label={language[this.props.defaultLanguage].location_name}
            placeholder={
              language[this.props.defaultLanguage].location_name_placeholder
            }
            value={this.state.location}
            onChange={(e) => this.onChangeInput("location", e)}
            error={this.state.error.location}
            leftIcon={icons.address}
          />
          <Input
            label={language[this.props.defaultLanguage].city}
            placeholder={language[this.props.defaultLanguage].city_placeholder}
            value={this.state.city}
            onChange={(e) => this.onChangeInput("city", e)}
            error={this.state.error.city}
            leftIcon={icons.city}
          />
          <Input
            label={language[this.props.defaultLanguage].postal_address}
            placeholder={
              language[this.props.defaultLanguage].postal_address_placeholder
            }
            value={this.state.postalAddress}
            onChange={(e) => this.onChangeInput("postalAddress", e)}
            error={this.state.error.postalAddress}
            leftIcon={icons.postal}
          />
          <Input
            label={language[this.props.defaultLanguage].postal_town}
            placeholder={
              language[this.props.defaultLanguage].postal_town_placeholder
            }
            value={this.state.town}
            onChange={(e) => this.onChangeInput("town", e)}
            error={this.state.error.town}
            leftIcon={icons.city}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { profileUnits } = state.ProfileUnits;
  return {
    defaultLanguage,
    profileUnits,
  };
};

export default connect(mapStateToProps)(BusinessAddress);
